import React, { useState, useEffect } from 'react';
import './News.css';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { newsService } from '../../services/newsService';

const News = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await newsService.getNews();
        setNewsItems(data.news);
      } catch (error) {
        console.error('Ошибка загрузки новостей:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const itemsPerView = 3;
  const totalItems = newsItems.length;
  const maxIndex = Math.max(0, totalItems - itemsPerView);

  const nextSlide = () => {
    if (currentIndex < maxIndex) {
      setCurrentIndex(prev => prev + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

  const visibleItems = newsItems.slice(currentIndex, currentIndex + itemsPerView);

  if (loading) {
    return <div className="news-loading">Загрузка...</div>;
  }

  return (
    <section className="news">
      <div className="container">
        <h2 className="news-title">Новости</h2>
        
        <div className="news-content">
          <button
            className={`nav-arrow prev left-arrow ${currentIndex === 0 ? 'disabled' : ''}`}
            onClick={prevSlide}
            disabled={currentIndex === 0}
          >
            <ArrowLeft />
          </button>
        
          <div className="news-carousel-container">
            <div className="news-grid">
              {visibleItems.map((item) => (
                <Link to={`/news/${item.id}`} key={item.id} style={{ textDecoration: 'none' }}>
                  <div className="news-card">
                    <div className="news-card-shadow"></div>
                    <div className="news-card-content">
                      <div className="news-image">
                        <img src={item.image} alt={item.title} />
                      </div>
                      <h3 className="news-item-title">{item.title}</h3>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            
            <div className="carousel-indicators">
              {Array.from({ length: maxIndex + 1 }).map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
          </div>
        
          <button
            className={`nav-arrow next right-arrow ${currentIndex >= maxIndex ? 'disabled' : ''}`}
            onClick={nextSlide}
            disabled={currentIndex >= maxIndex}
          >
            <ArrowRight />
          </button>
        </div>
        
        <div className="news-button-container">
          <Link to="/news" className="news-button-wrapper">
            <button className="news-button">
              <div className="news-button-shadow"></div>
              <div className="news-button-main">
                <span className="news-button-text">Больше</span>
              </div>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default News;